export const formatTwoDecimalPlaces = (value: number) => {
  return value.toFixed(2);
};

export const calculateImprovement = (preScore: number, postScore: number) => {
  return ((postScore - preScore) / preScore) * 100;
};

export const formatLargeNumber = (value: number) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatDate = (date: Date) => {
  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
}